<template>
  <form
    class="visit-expenses-form"
    @submit.prevent="saveExpensesAsync(true)"
    @keydown.enter.prevent
    ref="formRef"
    data-cy="visit-expenses-form"
  >
    <div class="visit-expenses-form__header-wrapper">
      <div class="visit-expenses-form__header">
        <strong>Expenses Incurred by RFR</strong>
        <small> (RFR out of pocket costs)</small>
      </div>
      <div class="visit-expenses-form__header amount">
        <strong> Amount</strong>
      </div>
    </div>
    <div class="visit-expenses-form__content">
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Mileage:
          <input
            v-model="formData.mileage"
            type="number"
            placeholder="0"
            min="0"
            step="1"
            required
            data-cy="mileage"
          />
          @ a rate of ${{ mileageRate }}
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="mileageAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            data-cy="mileage-amount"
            readonly
            disabled
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Airfare NOT charged to the OU
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.airfareAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="airfare-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Car Rental NOT charged to the OU
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.carRentalAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="car-rental-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">Tolls</div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.tollsAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="tolls-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">Parking</div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.parkingAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="parking-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Gas (only for car rental)
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.gasAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="gas-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Transit (taxi, train, bus etc.)
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.transitAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="transit-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">Motel</div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.motelAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="motel-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">Food</div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.foodAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="food-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">Misc</div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.miscAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="misc-amount"
          />
        </div>
      </div>
    </div>
    <div class="visit-expenses-form__footer">
      Balance Due RFR: $
      <input
        v-model="totalBalance"
        type="number"
        placeholder="0.00"
        step="0.01"
        data-cy="total-balance"
        readonly
        disabled
      />
    </div>

    <div class="visit-expenses-form__header-wrapper">
      <div class="visit-expenses-form__header">
        <strong>Corporate Charges</strong>
        <small>(Expenses Charged to OU Credit Card)</small>
      </div>
      <div class="visit-expenses-form__header amount">
        <strong>Amount</strong>
      </div>
    </div>

    <div class="visit-expenses-form__content">
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Airfare Charged to OU
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.airfareOUAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="airfare-ou-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Car Rental Charged to OU
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.carRentalOUAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="car-rental-ou-amount"
          />
        </div>
      </div>
      <div class="visit-expenses-form__content__row">
        <div class="visit-expenses-form__content__row__label">
          Misc and/or Hotel Charged to OU
        </div>
        <div class="visit-expenses-form__content__row__input">
          $
          <input
            v-model="formData.miscHotelOUAmount"
            type="number"
            placeholder="0.00"
            step="0.01"
            min="0"
            required
            data-cy="misc-hotel-ou-amount"
          />
        </div>
      </div>
    </div>

    <div class="visit-expenses-form__footer">
      Total Corporate Charges: $
      <input
        v-model="totalCorporateCharges"
        type="number"
        placeholder="0.00"
        step="0.01"
        data-cy="total-corporate-charges"
        readonly
        disabled
      />
    </div>

    <div class="visit-expenses-form__actions">
      <Button
        type="button"
        theme-color="dark"
        @click="onPreviousClicked"
        data-cy="previous-button"
        >Previous</Button
      >
      <LoadingButton
        type="button"
        theme-color="primary"
        data-cy="save-button"
        :loading="formSubmitting"
        :disabled="!submitAvailable"
        @click="saveExpensesAsync(false)"
      >
        Save My Form
      </LoadingButton>
      <LoadingButton
        type="submit"
        theme-color="dark"
        data-cy="next-button"
        :loading="formSubmitting"
        :disabled="!submitAvailable"
        >Next</LoadingButton
      >
    </div>
  </form>
</template>

<script setup lang="ts">
import { api } from "@/api";
import { EnumVisitMode } from "@/Domain/EnumVisitMode";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import LoadingButton from "@/shared/ui/inputs/LoadingButton.vue";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { computed, onBeforeMount, ref, watch } from "vue";
import { Button } from "@progress/kendo-vue-buttons";
import type { TripExpensesSummaryDisplay } from "@/Domain/TripExpensesSummaryDisplay";

interface FormData {
  mileage: number;
  airfareAmount: number;
  carRentalAmount: number;
  tollsAmount: number;
  parkingAmount: number;
  gasAmount: number;
  transitAmount: number;
  motelAmount: number;
  foodAmount: number;
  miscAmount: number;
  airfareOUAmount: number;
  carRentalOUAmount: number;
  miscHotelOUAmount: number;
}

const notificationStore = useNotificationStore();

const props = defineProps<{
  tripId: number;
  submitAvailable: boolean;
}>();

const urlParams = new URLSearchParams(window.location.search);
const menuUserRole = (urlParams.get("menu") as string) ?? "VisitsAsRfr";
const type =
  EnumVisitMode[urlParams.get("type") as keyof typeof EnumVisitMode] ??
  EnumVisitMode.Inspection;

const mileageRate = ref(0);
const formSubmitting = ref(false);
const tripExpenseSummary = ref<TripExpensesSummaryDisplay>();
const formRef = ref<HTMLFormElement>();
const formData = ref<FormData>({
  mileage: 0,
  airfareAmount: 0,
  carRentalAmount: 0,
  tollsAmount: 0,
  parkingAmount: 0,
  gasAmount: 0,
  transitAmount: 0,
  motelAmount: 0,
  foodAmount: 0,
  miscAmount: 0,
  airfareOUAmount: 0,
  carRentalOUAmount: 0,
  miscHotelOUAmount: 0,
});

const mileageAmount = computed(() => {
  return Number((formData.value.mileage * mileageRate.value).toFixed(2));
});

const totalBalance = computed(() => {
  const amounts = [
    mileageAmount.value,
    formData.value.airfareAmount,
    formData.value.carRentalAmount,
    formData.value.tollsAmount,
    formData.value.parkingAmount,
    formData.value.gasAmount,
    formData.value.transitAmount,
    formData.value.motelAmount,
    formData.value.foodAmount,
    formData.value.miscAmount,
  ];

  return amounts.reduce((acc, curr) => acc + (curr || 0), 0).toFixed(2);
});

const totalCorporateCharges = computed(() => {
  const charges = [
    formData.value.airfareOUAmount,
    formData.value.carRentalOUAmount,
    formData.value.miscHotelOUAmount,
  ];

  return charges.reduce((acc, curr) => acc + (curr || 0), 0).toFixed(2);
});

const getMileageRateAsync = async function () {
  return handleResponsePromiseAsync(
    api.get("GetMileageRateForRfr", {}),
    (data) => {
      mileageRate.value = data ?? 0;
    },
    "VisitExpensesForm.vue",
    "getMileageRateAsync"
  );
};

const saveExpensesAsync = async function (nextClicked: boolean = false) {
  try {
    if (
      formSubmitting.value ||
      !props.submitAvailable ||
      !formRef.value?.reportValidity()
    )
      return;

    formSubmitting.value = true;
    await handleResponsePromiseAsync(
      api.post("UpdateTripExpenseSummary", {
        TripId: props.tripId,
        Miles: formData.value.mileage,
        Airfare: formData.value.airfareAmount,
        CarRental: formData.value.carRentalAmount,
        Tolls: formData.value.tollsAmount,
        Parking: formData.value.parkingAmount,
        Gas: formData.value.gasAmount,
        Taxi: formData.value.transitAmount,
        Motel: formData.value.motelAmount,
        Food: formData.value.foodAmount,
        Misc: formData.value.miscAmount,
        OuAir: formData.value.airfareOUAmount,
        OuCarRental: formData.value.carRentalOUAmount,
        OuOther: formData.value.miscHotelOUAmount,
      }),
      (data) => {
        if (data) {
          notificationStore.notify({
            message: "Expenses saved successfully",
            type: NotificationTypeEnum.success,
            duration: 5000,
          });
          if (nextClicked) {
            onNextClicked();
          }
        } else {
          notificationStore.notify({
            message: "Error formSubmitting expenses",
            type: NotificationTypeEnum.error,
            duration: 5000,
          });
        }
      },
      "VisitExpensesForm.vue",
      "saveExpensesAsync"
    );
  } finally {
    formSubmitting.value = false;
  }
};

const getTripExpenseSummaryAsync = async function () {
  if (!props.tripId) return;

  return handleResponsePromiseAsync(
    api.get("GetTripExpensesSummary", {
      tripId: props.tripId,
      newTrip: true,
    }),
    (data) => {
      tripExpenseSummary.value = data;
      formData.value.mileage = data.Miles ?? 0;
      formData.value.airfareAmount = data.Airfare ?? 0;
      formData.value.carRentalAmount = data.CarRental ?? 0;
      formData.value.tollsAmount = data.Tolls ?? 0;
      formData.value.parkingAmount = data.Parking ?? 0;
      formData.value.gasAmount = data.Gas ?? 0;
      formData.value.transitAmount = data.Taxi ?? 0;
      formData.value.motelAmount = data.Motel ?? 0;
      formData.value.foodAmount = data.Food ?? 0;
      formData.value.miscAmount = data.Misc ?? 0;
      formData.value.airfareOUAmount = data.OuAir ?? 0;
      formData.value.carRentalOUAmount = data.OuCarRental ?? 0;
      formData.value.miscHotelOUAmount = data.OuOther ?? 0;
    },
    "VisitExpensesForm.vue",
    "getTripExpenseSummaryAsync"
  );
};

const onNextClicked = function () {
  window.location.href = `RfrTripLog?type=${EnumVisitMode[type]}&tripId=${props.tripId}&menu=${menuUserRole}&mode=new`;
};

const onPreviousClicked = async () => {
  await saveExpensesAsync();
  window.location.href = `RfrVisitsSearch?type=${EnumVisitMode[type]}&menu=${menuUserRole}`;
};

defineExpose({
  saveExpensesAsync,
});

// Reset negative and empty values to 0
watch(
  formData,
  () => {
    Object.keys(formData.value).forEach((key) => {
      const fieldKey = key as keyof FormData;

      if (
        (!formData.value[fieldKey] && formData.value[fieldKey] !== 0) ||
        formData.value[fieldKey].toString() == "-" ||
        formData.value[fieldKey] < 0
      ) {
        formData.value[fieldKey] = 0;
      }
    });
  },
  { deep: true }
);

watch(
  () => props.tripId,
  () => {
    getTripExpenseSummaryAsync();
  }
);

onBeforeMount(() => {
  getMileageRateAsync();
  getTripExpenseSummaryAsync();
});
</script>

<style scoped lang="scss">
.visit-expenses-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  &__header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-bottom: 1px solid #ddd;
  }

  &__header {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 0.95rem;
      color: #333;
    }

    small {
      font-size: 0.875rem;
      color: #777;
    }

    &.amount {
      margin-right: 60px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__label {
        flex: 1;
        color: #555;
      }

      &__input {
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }
  }

  &__footer {
    padding: 1rem;
    margin-top: 1rem;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.95rem;

    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }

  input {
    width: 100px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
}
</style>
